import React, { useEffect, useState } from 'react';
import Select, { components } from 'react-select';
import { getFlexSelectCustomStyle } from '../../assets/styles/multiple_select';

const FlexSelect = ({
  style = {},
  dataOptions,
  value,
  fieldName,
  placeholder = 'Selecione...',
  valueController,
  isMulti = false,
  labelName,
  valueName,
  closeMenuOnSelect = false,
  isClearable = false,
  isSearchable = true,
  isDisabled = false,
  minHeight = '',
  noOptionsMessage = () => 'Nenhuma Opção',
  tabIndex = 0,
  portalTarget = false,
  onChange = (values) => {}
}) => {
  const [options, setOptions] = useState([]);

  useEffect(() => {
    let arrayOptions = [];
    dataOptions.forEach((option) => {
      if (option) {
        arrayOptions.push({
          label: option[labelName],
          value: option[valueName]
        });
      }
    });
    setOptions([...arrayOptions]);
  }, [dataOptions, labelName, valueName]);

  const getSelectValues = (values) => {
    if (isMulti) {
      if (typeof values === 'string') {
        values = values.split(';');
      }
      let capsule = [];
      values.length > 0 &&
        values.forEach((el) => {
          dataOptions.forEach((option) => {
            if (option && option[valueName] && option[valueName] === el)
              capsule.push({
                label: option[labelName],
                value: option[valueName]
              });
          });
        });
      return capsule;
    } else {
      let capsule = [];
      dataOptions.forEach((option) => {
        if (option && option[valueName] === values)
          capsule.push({
            label: option[labelName],
            value: option[valueName]
          });
      });
      return capsule;
    }
  };

  const controlChange = (values) => {
    if (isMulti) {
      if (values && values.length > 0) {
        const a = values.map((l) => l.value);
        onChange(a);
        return valueController(fieldName, a);
      }
      onChange([]);
      return valueController(fieldName, []);
    } else {
      if (values) {
        onChange(values.value);
        return valueController(fieldName, values.value);
      }
      onChange(null);
      return valueController(fieldName, '');
    }
  };

  const getOptionData = (value) => {
    if (value)
      return dataOptions.filter(
        (option) => option && option[valueName] === value
      )[0];
  };

  const { Option } = components;
  const IconOption = (props) => {
    const data = getOptionData(props.data.value);

    return (
      <>
        {data?.divisorCategory ? (
          <p
            style={{
              fontWeight: 'bold',
              padding: '0.2rem 0px 0.2rem 0.6rem',
              margin: '0px'
            }}
          >
            {data?.divisorCategory}
          </p>
        ) : null}
        <Option {...props}>
          {data?.icon}
          {props?.data?.label}
          <div>{data?.optionSubtitle}</div>
        </Option>
      </>
    );
  };

  return (
    <>
      <Select
        isSearchable={isSearchable}
        tabIndex={tabIndex}
        isClearable={isClearable}
        isMulti={isMulti}
        name={fieldName}
        placeholder={placeholder}
        styles={{ ...getFlexSelectCustomStyle({ minHeight }), ...style }}
        value={getSelectValues(value)}
        onChange={controlChange}
        closeMenuOnSelect={closeMenuOnSelect}
        classNamePrefix="react-select"
        options={options}
        isDisabled={isDisabled}
        noOptionsMessage={noOptionsMessage}
        menuPortalTarget={portalTarget ? document.body : null}
        components={{ Option: IconOption }}
      />
    </>
  );
};

export default FlexSelect;
